import $ from 'jquery';
export default class ShowOnSelectValue {
    static init() {
        const $inputsHandler = $('.js__show-on-select-value');
        const $slaveInputs = $('.js__show-on-select-value-slave:not(.js__ignore-slave)');
        if ($inputsHandler.length) {
            $inputsHandler.on('change', e => {
                const $currentTarget = $(e.currentTarget);
                const $selectInput = $(e.currentTarget).find('select');
                if ($currentTarget.find('select').val() === $selectInput.data('on-value')) {
                    $slaveInputs.show();
                }
                else {
                    $slaveInputs.hide();
                }
            });
        }
        else {
            $slaveInputs.hide();
        }
        $inputsHandler.trigger('change');
    }
}
